import { IntegrationSummaryAnalyticsActionTypes } from './constants';

type IntegrationSummaryAnalyticsAction = { type: string, payload: {} | string };

export const integrationSummaryAnalyticsApiResponseSuccess = (actionType: string, data: any): IntegrationSummaryAnalyticsAction => ({
    type: IntegrationSummaryAnalyticsActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data },
});

export const integrationSummaryAnalyticsApiResponseError = (actionType: string, error: string): IntegrationSummaryAnalyticsAction => ({
    type: IntegrationSummaryAnalyticsActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, error },
});

export const integrationSummaryAnalyticsGetShipmentsCount = (query: string): IntegrationSummaryAnalyticsAction => ({
    type: IntegrationSummaryAnalyticsActionTypes.GET_SHIPMENTS_COUNT,
    payload: { query },
});

export const integrationSummaryAnalyticsGetShipmentRatesCount = (query: string): IntegrationSummaryAnalyticsAction => ({
    type: IntegrationSummaryAnalyticsActionTypes.GET_SHIPMENT_RATES_COUNT,
    payload: { query },
});

export const integrationSummaryAnalyticsGetAdjustmentsCount = (query: string): IntegrationSummaryAnalyticsAction => ({
    type: IntegrationSummaryAnalyticsActionTypes.GET_ADJUSTMENTS_COUNT,
    payload: { query },
});

export const integrationSummaryAnalyticsGetShipmentsWithRatesCount = (query: string): IntegrationSummaryAnalyticsAction => ({
    type: IntegrationSummaryAnalyticsActionTypes.GET_SHIPMENTS_WITH_RATES_COUNT,
    payload: { query },
});

export const integrationSummaryAnalyticsGetShipmentsWithNoRatesCount = (query: string): IntegrationSummaryAnalyticsAction => ({
    type: IntegrationSummaryAnalyticsActionTypes.GET_SHIPMENTS_WITH_NO_RATES_COUNT,
    payload: { query },
});

export const integrationSummaryAnalyticsGetSurchargesCount = (query: string): IntegrationSummaryAnalyticsAction => ({
    type: IntegrationSummaryAnalyticsActionTypes.GET_SURCHARGES_COUNT,
    payload: { query },
});

export const integrationSummaryAnalyticsGetNonZeroSurchargesCount = (query: string): IntegrationSummaryAnalyticsAction => ({
    type: IntegrationSummaryAnalyticsActionTypes.GET_NON_ZERO_SURCHARGES_COUNT,
    payload: { query },
});

export const integrationSummaryAnalyticsGetIntegrationSummary = (query: string): IntegrationSummaryAnalyticsAction => ({
    type: IntegrationSummaryAnalyticsActionTypes.GET_INTEGRATION_SUMMARY,
    payload: { query },
});
